import { Navigate, useLocation } from "react-router-dom";

// Release 1.9.0 W2 (D-O160): /shop-floor/purchasing became the Watch tab of the one Purchasing workspace. The old
// link's own query (vendor, shop, q, section) is kept and the tab is added, so saved links and VIPER links still open
// the same list.

export function mergeRedirect(target: string, search: string, hash = ""): string {
  const [pathname, query = ""] = target.split("?");
  const params = new URLSearchParams(search);
  for (const [k, v] of new URLSearchParams(query)) if (!params.has(k)) params.set(k, v);
  const s = params.toString();
  return `${pathname}${s ? `?${s}` : ""}${hash}`;
}

export function LegacyPurchasingRedirect() {
  const location = useLocation();
  return <Navigate to={mergeRedirect("/purchasing?tab=watch", location.search, location.hash)} state={location.state} replace />;
}
